const resource = 'countries'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  fetchAccountProAllowedCountries() {
    return $axios.$get('/v2/account/pro/allowed-countries')
  },

  getServiceName: name => 'countryService',
})
